import axios from 'axios';
import qs from 'qs';

import config from '../../config';
import { buildSecuredHeader } from '../../library/securedHeader';

const IS_ENABLE_SECURED_HEADER = process.env.REACT_APP_ENABLE_SECURED_HEADER === 'true';

// let store;
// export const injectStore = (_store) => {
//   store = _store;
// };

const axiosInstance = axios.create({
  paramsSerializer: function (params) {
    return qs.stringify(params, { encode: false });
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = buildHeaders(config);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    if ((response.status < 200 || response.status > 204) && !response.config.validateStatus?.(response.status)) {
      return parseError(response.data);
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      let errorMSG = 'Session has expired.  You will be logged-off.';
      localStorage.clear();
      localStorage.setItem('error', 'Session has expired.  Log-in again.');
      window.location.reload();
      return Promise.reject({ messages: errorMSG, reload: true });
    }

    if (error.response?.data?.errors) {
      return parseError(error.response.data.errors);
    }

    if (error.response?.data) {
      return parseError(error.response.data);
    }

    if (error.message && typeof error.message === 'string') {
      return Promise.reject({ messages: error.message });
    }

    return Promise.reject(error);
  },
);

const buildHeaders = (config) => {
  const apiToken = getSessionToken();

  const finalHeaders = {
    'X-Frame-Options': 'sameorigin',
    'X-XSS-Protection': '1; mode=block',
    'Strict-Transport-Security': 'max-age=63072000; includeSubDomains; preload',
    'X-Content-Type-Options': 'nosniff',
  };

  if (IS_ENABLE_SECURED_HEADER) {
    finalHeaders['X-Secured-Header'] = buildSecuredHeader();
  }

  if (apiToken) {
    finalHeaders['Authorization'] = apiToken;
  }

  return finalHeaders;
};

const getSessionToken = () => {
  if (!!localStorage.getItem('usersession')) {
    try {
      const userTenantSession = JSON.parse(localStorage.getItem('usersession'));

      if (!!userTenantSession?.accessToken) {
        return 'Bearer ' + userTenantSession?.accessToken;
      } else {
        return null;
      }
    } catch {
      return null;
    }
  }

  return null;
};

const parseError = (data) => {
  let returnErrorMessage = config.generalError;
  if (data) {
    if (data.errors) {
      if (data.errors instanceof Array) {
        returnErrorMessage = '';
        returnErrorMessage = data.errors.map((error) => error.title || error.value).join(' ');
      } else if (data.errors.message) {
        returnErrorMessage = data.errors.message;
      }
    } else if (data.message) {
      returnErrorMessage = data.message;
    } else if (data.ErrorMessage) {
      returnErrorMessage = (data.ErrorCode ? `${data.ErrorCode} - ` : '') + data.ErrorMessage;
    } else {
      returnErrorMessage = JSON.stringify(data);
    }
  }

  return Promise.reject({
    messages: returnErrorMessage,
  });
};

const http = axiosInstance;
export default http;
